import { Window } from "../Container/Window/Window";
import { SelectorHead } from "./SelectorHead";
import { SelectorItem } from "./SelectorItem";
import { List } from "../Container/List/List";
import { CFlexContainer } from "../Container/CFlexContainer";

export class Selector extends Window {

    public select(item: any): void {
        this.getItems().forEach((s: SelectorItem) => {
            if (s && s.equals(item)) {
                s.checked();
            }
        });
    }

    public deselectAll(): void {
        this.getItems().forEach((s: SelectorItem) => {
            s.unchecked();
        });
    }

    public getSelections() {
        const data = [];
        this.getItems().forEach((s: SelectorItem) => {
            if (s && s.isChecked()) {
                data.push(s.getValue());
            }
        });

        return data;
    }

    protected getItems() {
        return this.getList().getItems();
    }

    protected getList() {
        return this.get("list");
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.appendChild(this.createHead());
        this.addClass("ds");
        // Style optionnel : même fonctionnement, skin différent (data-ha-entry-style
        // → config `style`). Permet de réutiliser le même éditeur modal avec des
        // variantes visuelles sans dupliquer la logique de sélection.
        const style = this.get("style");
        if (style) { this.addClass(style); }
        this.initList();
    }

    protected initList() {
        const list = new List(new CFlexContainer());
        list.addClass("dl");

        const dataList = this.get("dlist");
        if (dataList) {
            dataList.forEach((data: Map<any, any>) => {
                list.addItem(this.createItem(data));
            });
        }
        this.addToData("list", list);
        this.appendChild(list);
    }

    protected createHead(data?: any) {
        return new SelectorHead(data);
    }

    protected createItem(data: any): SelectorItem {
        if (this.has("pfunc")) {
            data.set("pfunc", this.get("pfunc").itemClick);
        }

        return new SelectorItem(data);
    }
}
